module.exports = __webpack_public_path__ + "static/media/DC_F_Embroidery_Bicocca_DKGrey_White.f119c324.png";